package com.starparty.app.astro0.celestialbodies

import com.starparty.app.astro0.MathD
import com.starparty.app.astro0.SP_Colour

internal class Saturn(sun: Sun) :
    Planet(sun) {
    private val DEF_SATURN_COLOR = SP_Colour(252, 238, 173, 255)
    protected var mJupiter: Jupiter? = null
    fun setJupiter(j: Jupiter) {
        mJupiter = j
    }

    override fun addPerturbations() {
        super.addPerturbations()
        addPerturbationsForSaturnLongitude()
        addPerturbationsForSaturnLatitude()
    }

    protected fun addPerturbationsForSaturnLongitude() {
        val Ms = mOEs[M]
        val Mj = mJupiter!!.mOEs[M]
        mlonEcl = mlonEcl + +0.812 * MathD.sinD(2 * Mj - 5 * Ms - 67.6)
        mlonEcl = mlonEcl + -0.229 * MathD.cosD(2 * Mj - 4 * Ms - 2)
        mlonEcl = mlonEcl + +0.119 * MathD.sinD(Mj - 2 * Ms - 3)
        mlonEcl = mlonEcl + +0.046 * MathD.sinD(2 * Mj - 6 * Ms - 69)
        mlonEcl = mlonEcl + +0.014 * MathD.sinD(Mj - 3 * Ms + 32)
    }

    protected fun addPerturbationsForSaturnLatitude() {
        val Ms = mOEs[OrbitalBody.Companion.M]
        val Mj = mJupiter!!.mOEs[OrbitalBody.Companion.M]
        mlatEcl = mlatEcl + -0.020 * MathD.cosD(2 * Mj - 4 * Ms - 2)
        mlatEcl = mlatEcl + +0.018 * MathD.sinD(2 * Mj - 6 * Ms - 49)
    }

    init {
        rgbColour = DEF_SATURN_COLOR
        name = "Saturn"
        abbrevName = "\u2644"
        setOrbitalElementsData(OE_SATURN)
    }
}